import { AVAILABLE_MODEL_VERSIONS } from '@/app/constants';
import type { FormTabType, ModelVersion } from '@/app/types';
import type { HeroToolType } from '../../../types';

const VIDEO_SETTINGS_LABEL = '16:9 丨 5s 丨 1080p';
const IMAGE_SETTINGS_LABEL = '16:9 丨 1080p';

interface ToolTypeConfig {
  formType: Exclude<FormTabType, 'scene'>;
  modelVersion: ModelVersion;
  settingsLabel: string;
  needsImages: boolean;
  /** 是否需要 @ 提及（将图片嵌入提示词），image2video 的图片是独立关键帧，不需要提及 */
  needsMentions: boolean;
}

/** 获取指定表单类型的最新模型版本 */
const getLatestModelVersion = (formType: Exclude<FormTabType, 'scene'>): ModelVersion => {
  const versions = AVAILABLE_MODEL_VERSIONS[formType];
  return versions[versions.length - 1];
};

const TOOL_TYPE_CONFIG: Record<HeroToolType, ToolTypeConfig> = {
  text2video: {
    formType: 'text2video',
    modelVersion: getLatestModelVersion('text2video'),
    settingsLabel: VIDEO_SETTINGS_LABEL,
    needsImages: false,
    needsMentions: false,
  },
  text2image: {
    formType: 'text2image',
    modelVersion: getLatestModelVersion('text2image'),
    settingsLabel: IMAGE_SETTINGS_LABEL,
    needsImages: false,
    needsMentions: false,
  },
  reference2image: {
    formType: 'reference2image',
    modelVersion: getLatestModelVersion('reference2image'),
    settingsLabel: IMAGE_SETTINGS_LABEL,
    needsImages: true,
    needsMentions: true,
  },
  image2video: {
    formType: 'img2video',
    modelVersion: getLatestModelVersion('img2video'),
    settingsLabel: VIDEO_SETTINGS_LABEL,
    needsImages: true,
    needsMentions: false,
  },
  reference2video: {
    formType: 'character2video',
    modelVersion: getLatestModelVersion('character2video'),
    settingsLabel: VIDEO_SETTINGS_LABEL,
    needsImages: true,
    needsMentions: true,
  },
};

export const getToolTypeConfig = (toolType: HeroToolType): ToolTypeConfig => TOOL_TYPE_CONFIG[toolType];
